import { defaultMemoize } from 'reselect';

import {
    isResourceLoading,
    isResourceFailed,
    isResourceComplete,
    getResourceError,
} from './common';

const isCollateralRequestLoading = defaultMemoize(isResourceLoading);
const isCollateralRequestFailed = defaultMemoize(isResourceFailed);
const isCollateralRequestComplete = defaultMemoize(isResourceComplete);

const getCollateralRequestData = (state) => state.getIn(['app', 'collateralRequest']);

const getCollateralRequest = defaultMemoize((data) => data.get('collateralRequest'));
const getCollateralRequestUUID = defaultMemoize((data) => data.getIn(['collateralRequest', 'uuid']));
const getCollateralRequestError = defaultMemoize(getResourceError);

export {
    isCollateralRequestLoading,
    getCollateralRequestError,
    isCollateralRequestFailed,
    isCollateralRequestComplete,
    getCollateralRequestData,
    getCollateralRequest,
    getCollateralRequestUUID,
};
